import styled from 'styled-components'
import PropTypes from 'prop-types'

const gridArea = 'top'
const Wrap = styled.div`
  grid-area: ${gridArea};
  background-color: ${({ bgColor }) => bgColor};
`
const Top = ({ children, bgColor = 'white', ...rest }) => {
  return (
    <Wrap bgColor={bgColor} {...rest}>
      {children}
    </Wrap>
  )
}

Top.propTypes = {
  bgColor: PropTypes.string,
  children: PropTypes.node.isRequired
}
Top.slotName = 'PageTop'

export { Top, gridArea }
